import React, { useState } from "react";
import { useForm } from "react-hook-form";
import CommonHeading from "../../../../common/components/Custom Hooks/CommonHeading";
import CommonDivider from "../../../../common/components/divider/CommonDivider";
import DecontaminationAndCleaning from "../DecontaminationAndCleaning/DecontaminationAndCleaning";
import SterilizationProcessing from "../SterilizationProcessing/SterilizationProcessing";
import WrappingAndPackaging from "../WrappingAndPackaging/WrappingAndPackaging";

const CleaningWrappingSterilization = () => {
  const defaultValues = {
    categories: "Item",
  };
  const { control, watch } = useForm({ defaultValues });
  // const [view, setView] = useState("Decontamination & Cleaning");
  const viewOptions = [
    {
      name: "Decontamination & Cleaning",
      fill: "#DEEFFF",
      stroke: "#6B9ECD",
      textFill: "#4B7EAD",
    },
    {
      name: "Wrapping & Packaging",
      fill: "#EAE9FF",
      stroke: "#7E78D4",
      textFill: "#3D3696",
    },
    {
      name: "Sterilization Processing",
      fill: "#FFDFE9",
      stroke: "#FFA8E1",
      textFill: "#FF27B6",
    },
  ];
  const [view, setView] = useState("Decontamination & Cleaning");
  return (
    <div className="w-full">
      <div className="w-full">
        <h1>{CommonHeading("Cleaning / Wrapping /Sterilization")}</h1>
        <div className="flex w-full items-start justify-start  ">
          <div className="w-full">
            <div className="w-full">
              {/* <h1>{CommonHeading("Cleaning / Wrapping /Sterilization")}</h1> */}
              <div className="flex w-full items-start justify-start px-4">
                {viewOptions.map((option, index) => (
                  <button type="button" onClick={() => setView(option.name)}>
                    <svg
                      className="w-full h-auto max-w-[300px]" // Tailwind classes for responsiveness
                      viewBox="0 0 300 40"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      preserveAspectRatio="xMidYMid meet" // Ensures proper scaling
                    >
                      <path
                        d="M0.5 4C0.5 2.067 2.067 0.5 4 0.5H266.86L288.452 13.586C293.269 16.5054 293.269 23.4946 288.452 26.414L266.86 39.5H4C2.067 39.5 0.5 37.933 0.5 36V4Z"
                        fill={option.name === view ? "#073763" : option.fill}
                        stroke={
                          option.name === view ? "#073763" : option.stroke
                        }
                      />

                      <text
                        x="45%"
                        y="52%"
                        dominantBaseline="middle"
                        textAnchor="middle"
                        fontSize="16"
                        fontFamily="Arial"
                        fontWeight="600"
                        fill={option.name === view ? "#fff" : option.textFill}
                      >
                        {option.name}
                      </text>
                    </svg>
                  </button>
                ))}
              </div>
              <div className="my-2">
                <CommonDivider />
              </div>

              {(view == "Decontamination & Cleaning" && (
                <DecontaminationAndCleaning setView={setView} />
              )) ||
                (view == "Wrapping & Packaging" && (
                  <WrappingAndPackaging setView={setView} />
                )) ||
                (view == "Sterilization Processing" && (
                  <SterilizationProcessing setView={setView} />
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CleaningWrappingSterilization;